import React from "react";
import { useNavigate } from "react-router";
import { EmpdContext } from '../../Context';
import { useMsal } from '@azure/msal-react';
import { PROVIDER_REGISTRATION } from "../../Consts/siteVerbiage";
import { globe, researchDocs } from "../../Assets/Images";
import Hero from "../Hero";

const handleLoginClick = async (msalInstance: any, navigate:(value: string) => void) => {
	if( msalInstance.getActiveAccount()) {
		navigate('../provider/dashboard')
	} else {
		msalInstance.loginRedirect({
			authority: "https://globalempd.b2clogin.com/globalempd.onmicrosoft.com/B2C_1_EMPD",
			state: `${window.location.origin}/../provider/dashboard`,
			scopes: ['profile','openid'],
		})
	}
}

const ProviderRegistration = () => {
	const navigate = useNavigate();
	const { instance } = useMsal();

	const render = () => {
		return (
			<div>
				<Hero
					header={PROVIDER_REGISTRATION.HERO_TITLE}
					description={PROVIDER_REGISTRATION.HERO_DESCRIPTION}
					backgroundImage={researchDocs}
					coverImage={globe}
					buttonLabel="Sign Up"
					buttonOnClick={() => handleLoginClick(instance, navigate)}
				/>
			</div>
		)
	}

	return (
		<EmpdContext.Consumer>
			{() => render() }
		</EmpdContext.Consumer>
	)
}
export default ProviderRegistration
